import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 mb-3">
            <i className="ri-fire-fill mr-1"></i>实时热度
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门影视榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-500">基于实时播放数据的全网热度排名，每日更新</p>
        </div>

        <div className="space-y-2">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200/50 transition-colors duration-200 group cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span
                    className={`text-lg font-bold font-heading ${
                      item.rank === 1
                        ? 'text-primary-500'
                        : item.rank === 2
                          ? 'text-accent-400'
                          : 'text-secondary-400'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-lg font-bold text-foreground-500">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-base font-semibold text-foreground-800 group-hover:text-primary-400 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span
                    className={`flex-shrink-0 px-2 py-0.5 text-xs rounded-full font-medium ${
                      item.tagColor === 'accent'
                        ? 'bg-accent-500/15 text-accent-400'
                        : item.tagColor === 'primary'
                          ? 'bg-primary-500/15 text-primary-400'
                          : 'bg-secondary-500/15 text-secondary-400'
                    }`}
                  >
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.meta}</p>
              </div>

              <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center text-foreground-500 group-hover:text-primary-400 transition-colors">
                <i className="ri-play-circle-line text-lg"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}